import styled from "@emotion/styled/macro";
import { Button } from "@sunrun/experience-ui-components";

type SelfSupplyGraphLinkProps = {
  color?: "link" | "primary" | "secondary" | "tertiary";
  size?: "sm" | "md" | "lg";
  dataTestId?: string;
  onClick?: () => void;
  children?: React.ReactNode;
};

const SelfSupplyGraphLink = ({
  color = "link",
  size = "sm",
  dataTestId = "offer-review-self-supply-graph-link",
  onClick,
  children,
}: SelfSupplyGraphLinkProps) => {
  return (
    <Link color={color} size={size} data-testid={dataTestId} onClick={onClick}>
      {children || "Self supply seasonal graph"}
    </Link>
  );
};

const Link = styled(Button)`
  margin: 8px 0 0;
  align-self: flex-start;
  font-size: 14px;
`;

export { SelfSupplyGraphLink };
